import 'animate.css';
import 'video.js';
import 'video.js/dist/video-js.css';

// import 'swiper/css/bundle';

import Impact from './impact';
import Icons from './icons';
import Header from './header';
//import  from './what-we-do';
import Supporters from './supporters';
import Mapslider from './mapslider';
import Conflicts from './emerging-conflicts';
import Programs from './programs';
import Injustice from './injustice';
import ChanginTheWorld from './changing-the-world';
import NotOk from './not-ok';
import Changes from './changes';
import BreakingIsolation from './continuously-adapting';
import InAction from './in-action';


new InAction();

new BreakingIsolation();
new Changes();
new NotOk();
new ChanginTheWorld();
new Programs();
new Conflicts();
new Supporters();
//new HorizontalGraph();
new Icons();
new Header();
new Impact();
new Mapslider();
new Injustice();

const lightbox = GLightbox({
    selector: '.glightbox',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
});

$('a.learn-more.read-more').on('click', function(e) {
    e.preventDefault();
    console.log('click');
    $(this).toggleClass('active');
    $('.ceo p.extra').toggleClass('active');
})

// const player = new Plyr('.player');

// import Rellax from 'rellax';
// var rellax = new Rellax('.rellax', {
//     center: true
// });
// console.log('2');

// window.onload = function() {
//     var rellax = new Rellax('.rellax');
//     rellax.refresh();
// }